import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalComponent from "../../../../components/customComponents/ModalComponent/ModalComponent";
import { getCentricMessageList } from "../../../../../app/redux/slices/app/messageSlice.js";

import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck.js";
import MessageDetails from "../../../../../features/view/message/messageDetails.jsx";
import { formatDate } from "../../../../../features/utils/utils";
import CustomDatePicker from "../../../../../features/components/customComponents/customDatePicker/index";
import dayjs from "dayjs";

const MessageQueue = () => {
  const dispatch = useDispatch();
  const [showmessageDetails, setShowMessageDetails] = useState(false);
  const [caseId, setcaseId] = useState("");

  const [searchFilter, setSearchFilter] = useState({
    address: "",
    email: "",
    phone: "",
    fromDate: formatDate(new Date().setDate(new Date().getDate() - 1000)),
    toDate: formatDate(new Date()),
  });

  const CentricUsermessageList = useSelector(
    (state) => state.messageSlice.centricMessageList
  );

  useEffect(() => {
    dispatch(
      getCentricMessageList({
        name: "",
        ...searchFilter,
        page_size: 10,
        page_number: 1,
      })
    );
  }, []);

  const btnSearch = () => {
    dispatch(
      getCentricMessageList({
        name: "",
        ...searchFilter,
        page_size: 100,
        page_number: 1,
      })
    );
  };

  const btnClear = () => {
    setSearchFilter({
      address: "",
      email: "",
      phone: "",
      fromDate: formatDate(new Date().setDate(new Date().getDate() - 1000)),
      toDate: formatDate(new Date()),
    });
  };

  return (
    <>
      <div className="row  min-h-100">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch payment-card message-queue-card">
            <div className="card-header border-0 ">
              <div className="row align-items-center w-100 mt-2 g-2 bg-custom-light pb-2 px-2 search-filters">
                <div
                  className="d-flex justify-content-between align-items-center mb-2"
                  style={{ margin: "10px 0px", color: "#0A65E5" }}
                >
                  <h4>Search Account</h4>
                </div>
                <div className="row align-items-center w-100 mt-2 g-2 bg-custom-light pb-2 px-2 search-filters">
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="searchform-inputlabel">
                        Service Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Service Address"
                        name="street_address"
                        value={searchFilter.address}
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchFilter({
                            ...searchFilter,
                            address: e.target.value,
                          });
                        }}
                      />
                    </div>
                    {/* <div className="col-lg-3">
                      <label className="searchform-inputlabel">Community</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Community"
                        name="community"

                      />
                    </div> */}
                    <div className="col-lg-2">
                      <label className="searchform-inputlabel">Email</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Email"
                        name="email"
                        value={searchFilter.email}
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchFilter({
                            ...searchFilter,
                            email: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-2">
                      <label className="searchform-inputlabel">Phone</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Phone"
                        name="phone"
                        value={searchFilter.phone}
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchFilter({
                            ...searchFilter,
                            phone: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-2">
                      <label className="searchform-inputlabel">From Date</label>{" "}
                      <div>
                        <CustomDatePicker
                          value={searchFilter.fromDate}
                          onChange={(date) => {
                            const formattedDate = date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : "";
                            setSearchFilter({
                              ...searchFilter,
                              fromDate: formattedDate,
                            });
                          }}
                          name="startDate"
                          maxDate={new Date().toISOString().split("T")[0]}
                          showIcon={true}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <label className="searchform-inputlabel">To Date</label>{" "}
                      <CustomDatePicker
                        value={searchFilter.toDate}
                        onChange={(date) => {
                          const formattedDate = date
                            ? dayjs(date).format("YYYY-MM-DD")
                            : "";
                          setSearchFilter({
                            ...searchFilter,
                            toDate: formattedDate,
                          });
                        }}
                        name="startDate"
                        maxDate={new Date().toISOString().split("T")[0]}
                        showIcon={true}
                      />
                    </div>
                  </div>
                  <div className="row pt-3">
                    <div className="col-lg-3">
                      <button
                        style={{ marginTop: "20px", fontSize: "12px" }}
                        className="btn btn-custom electric_cobalt min-h-25px"
                        onClick={(e) => {
                          e.preventDefault();
                          btnSearch();
                        }}
                      >
                        Search
                      </button>
                      &ensp;
                      <button
                        style={{ marginTop: "20px", fontSize: "12px" }}
                        className="btn btn-custom startlit_navy min-h-25px"
                        onClick={(e) => {
                          e.preventDefault();
                          btnClear();
                        }}
                      >
                        Clear <i className="fas fa-eraser"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-header with_hr_tabs">
              <ul
                className="nav nav-tabs d-flex flex-fill"
                id="myTab"
                role="tablist"
              >
                <li
                  className="nav-item flex-fill text-center"
                  role="presentation"
                >
                  <button
                    className="nav-link w-100 active"
                    id="Allmessage-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Allmessage"
                    type="button"
                    role="tab"
                    aria-controls="Allmessage-tab-pane"
                    aria-selected="true"
                  >
                    All
                  </button>
                </li>
              </ul>
              <div className="head_btn align-items-center d-flex"></div>
            </div>
            <div className="card-body">
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="Allmessage"
                  role="tabpanel"
                  aria-labelledby="Allmessage-tab"
                  tabIndex="0"
                >
                  {!CentricUsermessageList.loader &&
                    CentricUsermessageList.data?.data &&
                    Object.values(CentricUsermessageList?.data?.data)
                      .filter(
                        (a) => a.title && a.title !== "" && a.discritpion !== ""
                      )
                      .sort(
                        (a, b) =>
                          new Date(b.created_date) - new Date(a.created_date)
                      )
                      .map((item, index) => (
                        <div
                          key={index}
                          className="card card-custom border-0 message-compact-view-card mb-2"
                          onClick={(e) => {
                            e.preventDefault();
                            setcaseId(item);
                            setShowMessageDetails(true);
                          }}
                        >
                          <div className="card-body p-2">
                            <div className="message-compact-view">
                              <div className="user-name">
                                {item?.name}
                                <div>{item?.phone}</div>
                                <div>{item?.email}</div>
                              </div>
                              <div className="message-content">
                                <div className="subject text-blue">
                                  {item?.title?.length > 100
                                    ? item?.title.substring(0, 99) + " ..."
                                    : item?.title}
                                </div>
                                <div className="description">
                                  {item?.description?.length > 125
                                    ? item?.description.substring(0, 124) +
                                      " ..."
                                    : item?.description}
                                </div>
                              </div>
                              <div className="time mx-5">
                                {formatDate(item.created_date) +
                                  ", " +
                                  new Date(
                                    item.created_date
                                  ).toLocaleTimeString()}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showmessageDetails && (
          <ModalComponent
            openModal={showmessageDetails}
            onClose={() => {
              setShowMessageDetails(false);
            }}
            modalId="messageDetails"
            mainheading="Message Details"
            modalContent={
              <MessageDetails
                case_id={caseId?.case_id}
                contactId={caseId?.contact_id}
              />
            }
            isLarge
          />
        )}
      </div>
    </>
  );
};

export default withRouteAccessCheck(MessageQueue);
